<template>
  <div>

    <v-stepper-step :complete="currentStep > isStep" :editable="currentStep > isStep" :step="isStep">Update Site Add-ons</v-stepper-step>

    <v-stepper-content :step="isStep">

      <v-row>
        <v-col>
          <template v-for="(ad,i) in addons">
            <v-row :key="i">

              <v-col cols="7">{{ad.name}}</v-col>

              <v-col cols="2">£{{ad.price.toFixed(2)}}</v-col>

              <v-col cols="3" class="py-1">
                <v-sheet max-width="70">

                  <template v-if="ad.allow_quantity">

                    <template v-if="!(['ADDITIONAL DDIs','Non-geographic number'].includes(ad.name)) && !isMemorableAdName(ad.name)">
                      <v-text-field v-model="ad.quantity" type="number" min=0 label="Quantity" outlined dense hide-details></v-text-field>
                    </template>

                    <template v-else>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <div v-bind="attrs" v-on="on">
                            <v-text-field v-model="ad.quantity" type="number" min=0 label="Quantity" disabled outlined dense hide-details></v-text-field>
                          </div>
                        </template>
                        <span>
                          
                          <template v-if="ad.name==='ADDITIONAL DDIs'">
                            Quantity cannot be amended because this add-on <br>
                            depends on the quantity of numbers that a customer <br>
                            may have as they get 1 number for free
                          </template>
                          
                          <template v-if="ad.name==='Non-geographic number'">
                            Quantity cannot be amended because this add-on <br>
                            depends on the quantity of non-geo numbers that <br>
                            the customer has
                          </template>

                          <template v-if="isMemorableAdName(ad.name)">
                            Quantity cannot be amended because this add-on <br>
                            depends on the quantity of memorable numbers that <br>
                            the customer has
                          </template>

                        </span>
                      </v-tooltip>
                    </template>

                  </template>

                  <template v-else><v-switch v-model="ad.selected" class="mt-0" hide-details></v-switch></template>

                </v-sheet>
              </v-col>

            </v-row>
          </template>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-divider />
          <v-btn color="primary" small @click="nextStep();">Continue</v-btn>
        </v-col>
      </v-row>

    </v-stepper-content>

  </div>
</template>

<script>
  export default {
    data() {
      return {}
    },
    props: ['currentStep','isStep','addons'],
    methods: {
      isMemorableAdName(name) {
        if (typeof name !== 'string') {
          return false;
        }
        return name.includes('Memorable number');
      },
      nextStep() {
        this.$emit('continue');
      },
    },
  }
</script>

<style lang="scss" scoped>
  .v-application--is-ltr .theme--light.v-stepper--vertical {
    .v-stepper__step {
      padding: 15px;
      margin: 10px;
    }
  }
  .v-stepper__wrapper { padding: 2px !important; }
</style>
